import { Button, DatePicker, Form, FormInstance, Input, Modal, Select, Switch } from "antd";
import { Holiday_Type } from "../../../constant/constant";
import dayjs, { Dayjs } from "dayjs";
import React from "react";
import resources from "../../../resources";
import { IHolidayFormData } from "../types/holidays.types";
import Locale from "../../../core/locale/locale";

interface HolidayCreateModalProps {
    form: FormInstance;
    open: boolean;
    setOpen: (value: boolean) => void;
    onModalCancel: () => void;
    onSubmit: (data: IHolidayFormData) => void;
}

const HolidayCreateModal = (props: HolidayCreateModalProps) => {
    const tempResources = resources.commonButtonText;
    const isEditMode = props.form.getFieldValue("id");

    async function handleFormFinish() {
        await props.form.validateFields()
            .then((formValues: IHolidayFormData) => {
                props.onSubmit(formValues);
                props.setOpen(false);
                props.form.resetFields();
            })
            .catch(() => console.error("Error while submitting form"));
    }

    const disableDate = (currentDate: Dayjs) => (
        //disable past date
        currentDate.valueOf() < dayjs().startOf('day').valueOf()
    );

    return (
        <Modal
            open={props.open}
            title={isEditMode ? "Update Holiday" : "Add Holiday"}
            onCancel={props.onModalCancel}
            className={"hrms-app pn-holiday__modal"}
            wrapClassName={"pn-holiday__modal-wrap"}
            footer={false}
        >
            <Form
                labelCol={{span: 6}}
                onFinish={handleFormFinish}
                form={props.form}
                initialValues={{
                    type: "NATIONAL_HOLIDAY",
                    notify: true,
                }}
            >
                <Form.Item
                    name="id"
                    hidden={true}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="Name"
                    name="name"
                    rules={[{required: true, message: 'Please enter holiday name!'}]}
                >
                    <Input placeholder={'Enter holiday name'} type={"text"}/>
                </Form.Item>
                <Form.Item
                    label="Type"
                    name="type"
                    rules={[{required: true, message: 'Please enter holiday type!'}]}
                >
                    <Select className={'pn-holiday__modal-select'}>
                        {Object.keys(Holiday_Type).map((key, index) => {
                                return <Select.Option key={key}
                                                      value={key}>{Holiday_Type[key as keyof typeof Holiday_Type]}</Select.Option>
                            }
                        )}
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Date"
                    name="date"
                    className={'pn-holiday__date-picker'}
                    rules={[{required: true, message: 'Please enter holiday date!'}]}
                >
                    <DatePicker
                        format={Locale.displayDate}
                        disabledDate={disableDate}
                    />
                </Form.Item>
                <Form.Item
                    label="Notify"
                    name="notify"
                    valuePropName="checked"
                >
                    <Switch/>
                </Form.Item>
                <Form.Item className="pn-holiday__modal-submit" label={null}>
                    <Button
                        type="primary"
                        htmlType="submit"
                    >
                        {tempResources.submitButton}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default HolidayCreateModal;
